<template>
  <div class="app-container">
    <el-card v-if="rowItem">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基本信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="等级名称">{{rowItem.name}}</el-descriptions-item>
        <el-descriptions-item label="等级学分标准">{{rowItem.startCredit}} - {{rowItem.endCredit}}</el-descriptions-item>
        <el-descriptions-item label="等级头衔"><el-image style="width: 50px; height: 50px" :src="rowItem.titleLevel" :preview-src-list="[rowItem.titleLevel]"></el-image></el-descriptions-item>
        <el-descriptions-item label="等级证书"><el-image style="width: 50px; height: 50px" :src="rowItem.certificateLevel" :preview-src-list="[rowItem.certificateLevel]"></el-image></el-descriptions-item>
        <el-descriptions-item label="星级标准"><span v-if="rowItem.standardLevel">每加{{rowItem.standardLevel}}学分得一颗星</span></el-descriptions-item>
        <el-descriptions-item label="创建时间">{{rowItem.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{rowItem.state?'启用':'禁用'}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
    }
  },
  created() {

  },
  methods: {
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
</style>
